<div class="flex flex-col h-[90dvh] max-h-full min-h-0 overflow-hidden">

  <!-- Header -->
  <div class="pb-2 p-6 gap-2 md:gap-4 flex flex-col shrink-0">
    <h1
      class="headline-small text-primary flex-1 text-center"
      data-testid="template-dialog-title"
    >
      {{ 'All blueprints' | translate }}
    </h1>

    @if (showBlueprints) {
      <p class="body-large text-inverse-surface">
        {{
          'Choose between the AI blueprints set up for your organisation, or your library of AI blueprints'
            | translate
        }}
      </p>
    }
  </div>

  <!-- Selector: fills remaining height -->
  <div class="flex-1 min-h-0 !mb-4 px-6 flex flex-col overflow-hidden">
    <app-template-selector
      class="flex-1 min-h-0"
      [loading]="isLoading"
      [templates]="templates"
      [selectedTemplates]="originalSelection"
      (selectionChange)="onSelectionChange($event)"
    >
    </app-template-selector>
  </div>

  <!-- Footer stays fixed -->
  <app-dialog-footer class="shrink-0">
    <div class="flex w-full gap-4 justify-end">
      <button
        mat-stroked-button
        (click)="onCancel()">
        {{ 'Cancel' | translate }}
      </button>
      <button
        mat-flat-button
        (click)="onConfirm()"
        [disabled]="isSaving"
      >
        <app-loading-spinner [loading]="isSaving" [diameter]="20">
          {{ 'Confirm selection' | translate }}
        </app-loading-spinner>
      </button>
    </div>
  </app-dialog-footer>

</div>